// Zusatzsektionen für die 17 neuen Leistungsseiten (Prompt 2) – je zwei
// weitere Abschnitte für Tiefe und interne Verlinkung.

export const SERVICES_NEW_EXTRA = {
  "kurzgutachten": [
    {
      h2: "Kurzgutachten bei Firmenwagen und Leasingfahrzeugen",
      paragraphs: [
        "Bei Firmen- und Leasingfahrzeugen genügt der Kostenvoranschlag oft nicht: Flottenmanagement und Leasinggesellschaften verlangen eine dokumentierte Schadensfeststellung mit Fotos. Das Kurzgutachten erfüllt genau diese Anforderung – kompakt genug für den schnellen Prozess, vollständig genug für die Akte.",
        "Für Flottenkunden erstellen wir Kurzgutachten im Rahmen fester Prozesse mit einheitlicher Dokumentation – Details auf unserer Seite zum Fuhrpark-Schadenmanagement.",
      ],
    },
    {
      h2: "Die häufigsten Irrtümer zum Kurzgutachten",
      paragraphs: [
        "Irrtum eins: „Ein Kurzgutachten ist ein halbes Gutachten.“ Falsch – es ist ein vollständiger Schadensnachweis, nur ohne die aufwendige Wertermittlung. Irrtum zwei: „Das Kurzgutachten akzeptiert die Versicherung nicht.“ Falsch – von einem zertifizierten Sachverständigen erstellt, wird es regulär akzeptiert. Irrtum drei: „Erst der Anwalt entscheidet, was nötig ist.“ Falsch – die richtige Dokumentenwahl entscheidet der Gutachter anhand des Schadens, nicht der Briefkopf.",
      ],
    },
  ],
  "beweissicherungsgutachten": [
    {
      h2: "Beweissicherung bei Fahrerflucht",
      paragraphs: [
        "Der Verursacher ist weg – aber seine Spuren nicht: Fremdlack an Ihrem Fahrzeug, Anprallhöhe, Deformationsrichtung und die Lage Ihres Fahrzeugs erzählen den Hergang. Wir sichern diese Beweise, solange sie frisch sind, und dokumentieren sie so, dass Polizei, Versicherung und gegebenenfalls die Verkehrsopferhilfe damit arbeiten können.",
        "Eile ist hier doppelt geboten: Regen und Straßenreinigung löschen Spuren binnen Tagen, und die Fristen für die Anzeige und die Meldung an die eigene Versicherung laufen.",
      ],
    },
    {
      h2: "Beweissicherung mit dem Handy: Was Sie selbst dokumentieren können",
      paragraphs: [
        "Bis wir vor Ort sind, können Sie selbst die wichtigsten Beweise sichern: Fotografieren Sie beide Fahrzeuge in Endstellung, die Unfallstelle mit Umgebung (Straßenschilder helfen bei der Ortung), alle Schäden aus Nähe und Ferne sowie Bremsspuren und Trümmerteile. Film-Standbilder von Dashcams sichern Sie am besten sofort separat – manche Geräte überschreiben alte Aufnahmen.",
      ],
    },
  ],
  "oldtimer-gutachten": [
    {
      h2: "Youngtimer: die unterschätzte Wertanlage",
      paragraphs: [
        "Zwischen Gebrauchtwagen und Oldtimer liegt der spannendste Markt: Youngtimer ab etwa 15 Jahren mit gutem Zustand entwickeln sich häufig im Wert nach oben – aber nur dokumentierte Fahrzeuge profitieren. Ein Wertgutachten zum heutigen Stichtag sichert den Stand: bei Verkauf, bei Wertsteigerung für die Versicherung und im Schadenfall als Beweis, was der Wagen vorher wert war.",
      ],
    },
    {
      h2: "Oldtimer-Gutachten und H-Kennzeichnung",
      paragraphs: [
        "Das H-Kennzeichen verlangt den Nachweis, dass das Fahrzeug mindestens 30 Jahre alt, weitgehend original und in gutem Zustand ist. Unsere Zustandsbewertung dokumentiert genau diese Punkte – Originalität der Substanz, fachgerechte Instandhaltung und Erhaltungszustand – als belastbare Grundlage für die Prüfstelle.",
      ],
    },
  ],
  "gebrauchtwagenbewertung": [
    {
      h2: "Die häufigsten Mängel, die wir bei Gebrauchtwagen finden",
      paragraphs: [
        "Aus hunderten Kaufprüfungen kennen wir die Klassiker: kaschierte Unfallschäden an Front und Heck, verschlissene Bremsen und Querlenker kurz vor der Fälligkeit, Ölfeuchtigkeit an Motor und Getriebe, abgelaufene Zahnriemen ohne dokumentierten Wechsel und Elektronikfehler, die nur im Fehlerspeicher sichtbar sind.",
        "Keiner dieser Befunde muss ein Kaufverbot sein – aber jeder ist ein Verhandlungsargument. Mit der dokumentierten Mängelliste handeln Sie den Preis auf das, was das Fahrzeug wirklich wert ist.",
      ],
    },
    {
      h2: "Bewertung für Finanzierung und Bank",
      paragraphs: [
        "Bei der Finanzierung hochwertiger Gebrauchter verlangen Banken und Leasinggesellschaften häufig eine unabhängige Wertermittlung des Sicherungsobjekts. Unser Gutachten erfüllt diese Anforderung: begründeter Marktwert, dokumentierter Zustand, unterschrieben vom zertifizierten Sachverständigen.",
      ],
    },
  ],
  "restwertgutachten": [
    {
      h2: "Unfallwagen verkaufen: Ihre Optionen im Überblick",
      paragraphs: [
        "Drei Wege stehen offen: der Verkauf an den Aufkäufer zum dokumentierten Restwert, die Reparatur und der Weiterverkauf als fachgerecht instand gesetztes Fahrzeug – oder die Reparatur und das Weiterfahren. Welcher Weg sich rechnet, entscheiden die Zahlen aus dem Gutachten: Wiederbeschaffungswert, Restwert und Reparaturkosten im Verhältnis.",
        "Wir legen Ihnen auf Wunsch verbindliche Kaufangebote für das beschädigte Fahrzeug vor – dann rechnen Sie mit echten Angeboten statt mit Schätzungen.",
      ],
    },
    {
      h2: "Restwert und Steuer: die Mehrwertsteuer-Falle",
      paragraphs: [
        "Bei der Totalschaden-Abrechnung spielt die Mehrwertsteuer eine versteckte Rolle: Verkaufen Sie das beschädigte Fahrzeug zum Restwert, kann je nach Konstellation Mehrwertsteuer auf den Restwert anfallen – Versicherer rechnen das unterschiedlich ab. Wir weisen im Gutachten die relevanten Beträge sauber aus, damit Ihr Steuerberater oder Anwalt die Abrechnung prüfen kann.",
      ],
    },
  ],
  "leasingrueckgabe-gutachten": [
    {
      h2: "Die häufigsten Rückgabe-Mängel im Überblick",
      paragraphs: [
        "Die Praxis der Rückgaben zeigt immer dieselben Streitpunkte: Steinschläge an Motorhaube und Front, Kratzer an Einstiegen und Ladekante, beschädigte Felgen, Flecken und Abnutzung im Innenraum sowie fehlende Schlüssel, Bordbücher oder das komplette Zubehör. Für jeden dieser Punkte kennen wir die Bewertungskataloge der Leasinggesellschaften – und wissen, wo sie überschießen.",
        "Mit unserem Gutachten vor der Rückgabe wissen Sie vorher, welche Positionen kommen werden, was sie wirklich kosten und welche Sie mit wenig Aufwand selbst beheben lassen.",
      ],
    },
    {
      h2: "Leasingrückgabe im Gewerbe: Flotten und Fuhrparks",
      paragraphs: [
        "Bei gewerblichen Flotten läppert sich die Rückgabe: Zehn Fahrzeuge mit je vier strittigen Positionen ergeben schnell fünfstellige Nachforderungen. Wir dokumentieren Flotten-Rückgaben im Rahmenprozess – jedes Fahrzeug vorab begutachtet, jede Abrechnung geprüft, jede Nachforderung einzeln bewertet. Details auf unserer Seite zum Fuhrpark-Schadenmanagement.",
      ],
    },
  ],
  "fuhrpark-schadenmanagement": [
    {
      h2: "Digitales Reporting: Alle Fälle auf einen Blick",
      paragraphs: [
        "Auf Wunsch erhalten Sie eine monatliche Übersicht aller laufenden und abgeschlossenen Schadenfälle: Schadenhöhe, Status, Ausfalltage und Regulierungsergebnis je Fahrzeug. Diese Zahlen brauchen Sie ohnehin – für die Versicherungsverhandlung, für die interne Abrechnung und für die Frage, welche Fahrzeuge die Kosten treiben.",
      ],
    },
    {
      h2: "Prävention: Die billigsten Schäden sind die, die nie passieren",
      paragraphs: [
        "Zum Schadenmanagement gehört für uns auch die Prävention: Wir erstellen Ihren Fahrern auf Wunsch eine kompakte Unfallkarte fürs Handschuhfach – mit den wichtigsten Schritten am Unfallort und der direkten Rufnummer. Fahrer, die wissen, was zu tun ist, dokumentieren besser, vermeiden Schuldanerkenntnisse und sparen Ihrem Unternehmen bares Geld.",
      ],
    },
  ],
  "reparaturbestaetigung": [
    {
      h2: "Die Reparaturbestätigung beim Wiederverkauf",
      paragraphs: [
        "Ein Unfallwagen mit dokumentierter fachgerechter Reparatur verkauft sich spürbar besser: Die Bestätigung mit Vorher-Nachher-Fotos nimmt Käufern die größte Angst – die vor versteckten Folgeschäden. Wer seine Unfallhistorie transparent dokumentiert, erzielt erfahrungsgemäß bessere Preise als der, der sie verschweigt und erwischt wird.",
      ],
    },
    {
      h2: "Was die Bestätigung nicht leistet – ehrlich benannt",
      paragraphs: [
        "Die Reparaturbestätigung beurteilt die Reparatur des dokumentierten Schadens – sie ist keine Gesamtzustandsbewertung des Fahrzeugs und keine Garantie auf die Werkstattleistung. Brauchen Sie Letzteres im Gewährleistungsstreit mit der Werkstatt, ist die gutachterliche Stellungnahme oder eine Mängeldokumentation das richtige Instrument. Wir sagen Ihnen am Telefon, was zu Ihrem Fall passt.",
      ],
    },
  ],
  "nutzungsausfallbestaetigung": [
    {
      h2: "Nutzungsausfall bei Selbstständigen und Flotten",
      paragraphs: [
        "Wer mit dem Fahrzeug Geld verdient, hat mehr als einen privaten Nutzungsausfall: Der Handwerks-Sprinter, das Taxi, der Vertriebswagen erwirtschaften Umsatz. Hier greifen erweiterte Ansprüche – konkrete Ausfallkosten statt Pauschalsätze. Wir dokumentieren die betriebliche Nutzung und beziffern den Ausfall so, wie gewerbliche Schadenabteilungen es akzeptieren.",
      ],
    },
    {
      h2: "Die Ausfallzeit im Detail: Reparatur, Wiederbeschaffung, Verzögerung",
      paragraphs: [
        "Die Ausfallzeit setzt sich zusammen aus der technisch angemessenen Reparaturdauer (aus den kalkulierten Arbeitswerten), einer realistischen Ersatzteil-Beschaffungszeit und beim Totalschaden aus der Wiederbeschaffungsdauer für Suche, Kauf und Zulassung des Ersatzfahrzeugs. Jede Komponente begründen wir einzeln – pauschale Kürzungen der Versicherung laufen damit ins Leere.",
      ],
    },
  ],
  "reparaturrechnungspruefung": [
    {
      h2: "Die häufigsten Rechnungsfehler im Überblick",
      paragraphs: [
        "In der Praxis finden wir immer wieder dieselben Punkte: doppelt berechnete Arbeitswerte (etwa Ein- und Ausbau plus Instandsetzung derselben Position), Originalteile berechnet, aber Nachbauteile verbaut, Lackierzeiten über den Herstellervorgaben und Kleinteilepauschalen ohne Bezug zum Schaden. Einzeln klein, summieren sie sich regelmäßig auf dreistellige Beträge.",
      ],
    },
    {
      h2: "Für Werkstätten: Die neutrale Prüfung als Argument",
      paragraphs: [
        "Nicht nur Kunden zweifeln an Rechnungen – manchmal bezweifelt die Versicherung die Kalkulation einer Werkstatt, obwohl sie korrekt ist. Unsere neutrale Prüfung bestätigt dann die Angemessenheit: Für die Werkstatt ist das der schnellste Weg aus der Diskussion, für die Versicherung der Beleg, dass alles seine Richtigkeit hat. Wir prüfen in beide Richtungen – der Maßstab bleibt derselbe.",
      ],
    },
  ],
  "lackschichtdickenmessung": [
    {
      h2: "So funktioniert die Messung technisch",
      paragraphs: [
        "Das Messgerät nutzt das magnetische Induktions- beziehungsweise Wirbelstromprinzip: Es misst den Abstand zwischen Sensor und Metallträger durch die Lackschicht hindurch – auf Stahl und Aluminium, berührungslos und zerstörungsfrei. Jedes Bauteil wird an mehreren Punkten gemessen; die Werte fließen als Messprotokoll ins Gutachten.",
      ],
    },
    {
      h2: "Typische Messwerte und ihre Bedeutung",
      paragraphs: [
        "Werkslack liegt je nach Hersteller meist zwischen etwa 80 und 140 Mikrometern. Werte zwischen 150 und 250 deuten auf eine Zweitlackierung hin, darüber auf mehrfache Nachlackierung oder Spachtelung. Aber Vorsicht bei der Interpretation: Auch werksseitige Sonderschichten und Kunststoff-Additive verändern Werte. Deshalb bewerten wir immer das Gesamtbild – Messwerte, Spaltmaße, Befestigungsspuren und Lackoberfläche.",
      ],
    },
  ],
  "achsvermessung-rahmenvermessung": [
    {
      h2: "Die Kontrollvermessung nach der Reparatur",
      paragraphs: [
        "Nach Instandsetzung von Achs- oder Strukturschäden belegt die Kontrollvermessung, dass die Geometrie wieder im Soll liegt – der Nachweis, den die 130-%-Abrechnung und der spätere Wiederverkauf brauchen. Gerade nach Richtarbeiten an der Karosserie ist sie der Unterschied zwischen „repariert“ und „nachweisbar fachgerecht repariert“.",
      ],
    },
    {
      h2: "Rahmenvermessung bei Nutzfahrzeugen und Wohnmobilen",
      paragraphs: [
        "Leiterrahmen von Transportern, Wohnmobil-Aufbauten und Anhängergestelle verhalten sich anders als PKW-Selbsttragkarosserien: Verformungen zeigen sich in anderen Messpunkten, und die Toleranzen sind fahrzeugspezifisch. Wir vermessen auch Nutzfahrzeuge und Aufbauten – mit den Sollmaßen des jeweiligen Herstellers.",
      ],
    },
  ],
  "motorrad-gutachten": [
    {
      h2: "Saisonstart-Check und Kaufberatung fürs Motorrad",
      paragraphs: [
        "Zum Saisonstart prüfen wir gebrauchte Maschinen vor dem Kauf: Gabeldichtungen, Kettensatz, Reifenalter, Bremsen und die Frage aller Fragen – Sturzfreiheit. Die Lenkkopflager, Spiegelgewinde und Fußrasten erzählen erfahrenen Augen mehr als jede Verkäuferzusage. Mit der Kaufprüfung fahren Sie in die Saison, statt in die Werkstatt.",
      ],
    },
    {
      h2: "Roller und Leichtkrafträder: Die unterschätzte Stadtflotte",
      paragraphs: [
        "125er-Roller und Leichtkrafträder sind in der Stadt täglich im Einsatz – und täglich im Risiko. Auch hier gilt nach unverschuldetem Unfall: Das Gutachten ist für Geschädigte kostenlos, die gegnerische Versicherung zahlt. Gerade bei Rollern mit Verkleidung summieren sich die kleinen Positionen schnell über die Bagatellgrenze.",
      ],
    },
  ],
  "wohnmobil-gutachten": [
    {
      h2: "Wohnwagen und Camper-Anhänger: Besonderheiten",
      paragraphs: [
        "Wohnwagen haben keine eigene Kfz-Haftpflicht – die zieht über das Zugfahrzeug mit. Im Schadenfall und bei Kauf oder Verkauf zählen dieselben Aufbau-Themen wie beim Reisemobil: Dichtheit, Feuchtigkeit, Gestell und die Elektroinstallation. Wir begutachten Wohnwagen inklusive Deichsel, Auflaufbremse und Stützen – die sicherheitsrelevanten Teile, die beim Kauf gern übersehen werden.",
      ],
    },
    {
      h2: "Die Frühjahrs-Bewertung vor der Saison",
      paragraphs: [
        "Vor dem Verkauf oder der Saison lohnt die Zustandsdokumentation: Feuchtigkeitsmessung nach dem Winter, Dichtigkeitsprüfung der Aufbauten, Technik-Check der Basis. Verkäufer belegen damit den Zustand zum Saisonstart – Käufer bekommen Sicherheit vor dem teuersten aller Wohnmobil-Probleme: dem versteckten Wasserschaden.",
      ],
    },
  ],
  "e-auto-gutachten": [
    {
      h2: "E-Auto kaufen: Die Batterie entscheidet",
      paragraphs: [
        "Zwei identische E-Autos können tausende Euro auseinanderliegen – je nach Batteriezustand. State of Health, Ladeverhalten (viel Schnellladen altert schneller) und Thermomanagement entscheiden über Restreichweite und Wert. Unsere Kaufprüfung liest aus, was das Fahrzeug hergibt, und ordnet den Batteriezustand marktgerecht ein.",
      ],
    },
    {
      h2: "Hybrid-Gutachten: Zwei Antriebe, eine Bewertung",
      paragraphs: [
        "Plug-in-Hybride vereinen beide Welten – und beide Schadenlogiken: Verbrenner-Technik plus Hochvolt-System. Im Gutachten bewerten wir beide Antriebsstränge, inklusive der Frage, ob nach einem Unfall die herstellerseitigen Hochvolt-Freigabeprozesse nötig sind. Das entscheidet nicht selten über Reparaturfähigkeit und -kosten.",
      ],
    },
  ],
  "hagelschaden-gutachten": [
    {
      h2: "Hagelschaden am Leasingfahrzeug",
      paragraphs: [
        "Bei Leasingfahrzeugen kommt zur Teilkasko-Regulierung die Leasinggesellschaft hinzu: Reparaturvorgaben, Vertragswerkstatt-Pflicht und die Frage, ob die Instandsetzung vor der Rückgabe erfolgen muss. Wir stimmen Gutachten und Vorgehen mit allen Beteiligten ab – damit der Hagelschaden nicht bei der Rückgabe ein zweites Mal teuer wird.",
      ],
    },
    {
      h2: "Nach dem Unwetter: die ersten 48 Stunden",
      paragraphs: [
        "Melden Sie den Schaden Ihrer Versicherung sofort – schriftlich oder online, mit Datum und Wetterereignis. Verändern Sie nichts am Fahrzeug, bis dokumentiert ist. Und vereinbaren Sie früh den Besichtigungstermin: Nach großen Hagelereignissen sind Gutachter-Termine innerhalb weniger Tage vergeben. Wer zuerst dokumentiert, wird zuerst reguliert.",
      ],
    },
  ],
  "technische-beratung": [
    {
      h2: "Beratung bei Reparatur-Alternativen: Smart Repair bis Instandsetzung",
      paragraphs: [
        "Nicht jede Delle braucht die Lackierkabine: Smart Repair, Ausbeultechnik und Teilreparaturen sind oft die wirtschaftlich kluge Antwort – aber eben nicht immer. Wir beurteilen fachlich, welche Methode Ihrem Fahrzeug und Ihrem Schaden gerecht wird, ohne Auftragsinteresse an der Reparatur. Diese Unabhängigkeit ist der eigentliche Wert der Beratung.",
      ],
    },
    {
      h2: "Technische Beratung für Käufer von Firmen- und Jahreswagen",
      paragraphs: [
        "Jahreswagen und Werksdienstwagen sind attraktiv – aber sie haben ein Jahr Vollgas hinter sich. Wir prüfen vor dem Kauf, was die Historie verschweigt: Verschleiß jenseits der Laufleistung, kaschierte Flottenschäden, die Plausibilität der Wartung. Für Händler dokumentieren wir umgekehrt den einwandfreien Zustand als Verkaufsargument.",
      ],
    },
  ],
};
